export default "__VITE_ASSET__D51RTPIF__"